const a = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g fill="currentColor" clip-path="url(#a)"><path d="M2 1.8a1 1 0 0 1 1-1h2.667a1 1 0 0 1 1 1v12.667a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm7.333 0a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1v12.667a1 1 0 0 1-1 1h-2.667a1 1 0 0 1-1-1z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  a as default
};
